import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React, {useCallback} from 'react';

import BenchlingConfig from 'BenchlingConfig';
import getTestProps from 'test/lib/cypress/getTestProps';
import {GRAY_DARK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {ElementMouseEvent} from 'util/Types';

import {ScrollableTableRow} from './ScrollableTableConstants';

interface ScrollableTableHoverCellProps extends FixedDataTable.ColumnCellProps {
  onContextMenu?: (row: ScrollableTableRow, e: ElementMouseEvent) => void;
  rowWidth: number;
  rows: Array<ScrollableTableRow>;
}

export default function ScrollableTableHoverCell({
  rowIndex,
  rows,
  rowWidth,
  onContextMenu,
}: ScrollableTableHoverCellProps): JSX.Element {
  const row = rows[rowIndex];

  const handleContextMenu = useCallback(
    (e: ElementMouseEvent) => {
      if (onContextMenu) {
        onContextMenu(row, e);
      }
    },
    [onContextMenu, row]
  );

  return (
    <div
      className={classNames('scrollableTable-cell scrollableTable-cell--noContents', row.className)}
      onContextMenu={handleContextMenu}
    >
      <div
        className="scrollableTable-hoverContainer"
        style={{width: rowWidth}}
        {...getTestProps({component: 'ScrollableTableHoverCell', element: 'hoverContainer'})}
      >
        {BenchlingConfig.ENABLE_SIGHTGLASS_V3_GROUP_BY && row.isExpandable ? (
          <DisclosureTriangle isExpanded={row.isExpanded ?? false} />
        ) : null}
      </div>
    </div>
  );
}

function DisclosureTriangle({isExpanded}: {isExpanded: boolean}): JSX.Element {
  return (
    <div className={css(styles.disclosureTriangleContainer)}>
      <BenchlingIcon
        icon={isExpanded ? 'triangle-down' : 'triangle-right'}
        className={css(styles.disclosureTriangle)}
      />
    </div>
  );
}

const styles = StyleSheet.create({
  disclosureTriangleContainer: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
  },
  disclosureTriangle: {
    width: '1.25em',
    boxSizing: 'content-box',
    padding: '0 1em',
    color: GRAY_DARK,
  },
});
